export default {
  placeholders: {
    delivery_zip_code: 'CAP',
    delivery_city: 'Città',
    delivery_street_number: 'Numero civico',
    delivery_street_name: 'Nome via',
    type_your_address: 'Inserisci il tuo indirizzo',
  },
  errors: {
    address_suggestions_unavailable:
      'Impossibile caricare i suggerimenti di indirizzo. Puoi comunque inserire il tuo indirizzo qui sotto.',
  },
  buttons: {
    retry: 'Riprova',
  },
};
